<template>
  <el-dialog
    title="特殊公告设置"
    :visible="visible"
    width="520px"
    :close-on-click-modal="false"
    class="page-dialog center-dialog"
    @update:visible="val => $emit('update:visible', val)"
    @closed="handleClosed"
  >
    <div class="dialog-content">
      <div class="tip">温馨提示：只有勾选的 VIP 等级会员可以看到特殊公告弹窗</div>

      <el-form ref="formRef" :model="form" label-position="top" size="small">
        <el-form-item label="VIP 等级" prop="vip_limit">
          <div class="vip-checkboxes">
            <el-checkbox v-model="checkAll" @change="handleCheckAllChange"> 全选 </el-checkbox>
            <div class="vip-items">
              <el-checkbox-group v-model="form.vip_limit" @change="handleCheckedVipChange">
                <el-checkbox v-for="item in vipOptions" :key="item.value" :label="item.value">
                  {{ item.label }}
                </el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" :loading="loading" @click="handleConfirm">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getAnnouncementSpecialLimit, setAnnouncementSpecialLimit } from '@/api/content/announcement'
import { useVipOptions } from '@/composables/useVipOptions'
import { watch } from 'vue'

export default {
  name: 'SpecialNoticeSettingDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        vip_limit: [],
      },
      vipOptions: [],
      checkAll: false,
      isIndeterminate: false,
      loading: false,
      stopVipWatch: null,
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.loadData()
      }
    },
  },
  created() {
    const { vipOptions } = useVipOptions()
    this.stopVipWatch = watch(
      vipOptions,
      val => {
        this.vipOptions = Array.isArray(val) ? val : []
        this.updateCheckAll()
      },
      { immediate: true }
    )
  },
  beforeDestroy() {
    if (typeof this.stopVipWatch === 'function') this.stopVipWatch()
  },
  beforeUnmount() {
    if (typeof this.stopVipWatch === 'function') this.stopVipWatch()
  },
  methods: {
    async loadData() {
      try {
        const resp = await getAnnouncementSpecialLimit()
        if (resp && resp.code === 0 && resp.data && Array.isArray(resp.data.vip_limit)) {
          this.form.vip_limit = resp.data.vip_limit
        } else {
          this.form.vip_limit = []
        }
      } catch (e) {
        this.form.vip_limit = []
      } finally {
        this.updateCheckAll()
      }
    },

    handleCheckAllChange(val) {
      this.form.vip_limit = val ? this.vipOptions.map(i => i.value) : []
      this.isIndeterminate = false
    },

    handleCheckedVipChange(value) {
      const checkedCount = value.length
      this.checkAll = checkedCount === this.vipOptions.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.vipOptions.length
    },

    updateCheckAll() {
      const count = this.form.vip_limit.length
      this.checkAll = count === this.vipOptions.length
      this.isIndeterminate = count > 0 && count < this.vipOptions.length
    },

    handleCancel() {
      this.$emit('update:visible', false)
    },

    handleClosed() {
      // 重置状态
      this.form.vip_limit = []
      this.checkAll = false
      this.isIndeterminate = false
    },

    async handleConfirm() {
      this.loading = true
      try {
        const resp = await setAnnouncementSpecialLimit({
          vip_limit: this.form.vip_limit,
        })
        if (resp && resp.code === 0) {
          this.$message.success('保存成功')
          this.$emit('success')
          this.handleCancel()
        } else if (resp) {
          this.$message.error(resp.msg || '保存失败')
        }
      } catch (e) {
        this.$message.error(e.message || '保存失败')
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.dialog-content {
  padding-bottom: 12px;
}

.tip {
  margin-bottom: 16px;
  padding: 10px 12px;
  background-color: #f5f7fa;
  border-radius: 4px;
  color: #606266;
  font-size: 13px;
}

.vip-checkboxes {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.vip-items {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 16px;
}
</style>
